import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 271.34 305.78"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="">
        <path d="M243.8,253.9H27.54c-15.19,0-27.54-12.35-27.54-27.54V88.73c0-15.19,12.35-27.54,27.54-27.54h9.97c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06h-9.97c-11.81,0-21.42,9.61-21.42,21.42v137.64c0,11.81,9.61,21.42,21.42,21.42h216.26c11.81,0,21.42-9.61,21.42-21.42V88.73c0-11.81-9.61-21.42-21.42-21.42h-9.99c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06h9.99c15.19,0,27.54,12.35,27.54,27.54v137.64c0,15.19-12.35,27.54-27.54,27.54Z" />
        <path d="M166.14,305.78h-60.94c-1.69,0-3.06-1.37-3.06-3.06v-51.87c0-1.69,1.37-3.06,3.06-3.06h60.94c1.69,0,3.06,1.37,3.06,3.06v51.87c0,1.69-1.37,3.06-3.06,3.06ZM108.26,299.66h54.82v-45.75h-54.82v45.75Z" />
        <path d="M179.32,305.78h-87.31c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06h87.31c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06Z" />
        <path d="M244.72,224.18H26.62c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06h218.1c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06Z" />
        <path d="M213.41,164.98c-1.69,0-3.06-1.37-3.06-3.06V44.69L171.78,6.12H60.97v155.8c0,1.69-1.37,3.06-3.06,3.06s-3.06-1.37-3.06-3.06V3.06c0-1.69,1.37-3.06,3.06-3.06h115.14c.81,0,1.59.32,2.16.9l40.36,40.36c.57.57.9,1.35.9,2.16v118.5c0,1.69-1.37,3.06-3.06,3.06Z" />
        <path d="M213.41,46.48h-40.36c-1.69,0-3.06-1.37-3.06-3.06V3.06c0-1.24.75-2.35,1.89-2.83,1.14-.47,2.46-.21,3.33.66l40.36,40.36c.87.87,1.14,2.19.66,3.33-.47,1.14-1.59,1.89-2.83,1.89ZM176.11,40.36h29.91l-29.91-29.91v29.91Z" />
        <path d="M151.79,50.93h-32.27c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06h32.27c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06Z" />
        <path d="M173.05,86.28h-74.77c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06h74.77c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06Z" />
        <path d="M173.05,116.42h-74.77c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06h74.77c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06Z" />
      </g>
    </svg>
  )
}

export default Icon
